var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBagShopping = function SvgBagShopping(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160 96v32h128V96c0-35.3-28.7-64-64-64s-64 28.7-64 64m-32 64H48c-8.8 0-16 7.2-16 16v240c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V176c0-8.8-7.2-16-16-16h-80v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80H160v80c0 8.8-7.2 16-16 16s-16-7.2-16-16zm0-32V96c0-53 43-96 96-96s96 43 96 96v32h80c26.5 0 48 21.5 48 48v240c0 53-43 96-96 96H96c-53 0-96-43-96-96V176c0-26.5 21.5-48 48-48z"
  })));
};
export default SvgBagShopping;